import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { StyleFillType } from '../../input/enums';
import { DropdownProperty } from '../enums';

const DropdownProps = {
  props: {
    [DropdownProperty.Id]: {
      default: '',
      type: String,
    },
    [DropdownProperty.MenuClassName]: {
      default: '',
      type: String,
    },
    [DropdownProperty.Value]: {
      default: '',
      type: String,
    },
    [DropdownProperty.IsReadonly]: {
      default: false,
      type: Boolean,
    },
    [DropdownProperty.ErrorMessage]: {
      default: '',
      type: String,
    },
    [DropdownProperty.Placeholder]: {
      default: '',
      type: String,
    },
    [DropdownProperty.IsShowErrorMessage]: {
      default: false,
      type: Boolean,
    },
    [DropdownProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [DropdownProperty.IconColor]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [DropdownProperty.ColorScheme]: {
      default: StyleColorSchemeType.SecondaryLight,
      type: String,
    },
    [DropdownProperty.LabelColorScheme]: {
      default: StyleColorSchemeType.Primary,
      type: String,
    },
    [DropdownProperty.FillType]: {
      default: StyleFillType.Underlined,
      type: String,
    },
    [DropdownProperty.Label]: {
      default: '',
      type: String,
    },
    [DropdownProperty.HideOnContentClick]: {
      default: false,
      type: Boolean,
    },
    [DropdownProperty.IsRequired]: {
      default: false,
      type: Boolean,
    },
  },
};

export default DropdownProps;
